export default "__VITE_ASSET__effc0699__"